/* tslint:disable:no-console */
/* tslint:disable:no-debugger */
/* tslint:disable:no-unsafe-any */

import { getIEVersion } from './helpers/browser'

const isRunningInIE = getIEVersion() > 0

export const traceColor = 'color:black'
export const infoColor = 'color:green'
export const warningColor = 'color:Orange'
export const errorColor = 'color:red'
export const eventColor = 'color:blue'
export const colored = true

let enabled = false

export function isEnabled(): boolean {
  // tslint:disable-next-line:strict-type-predicates
  return enabled && console !== null && console.log !== null
}

export function setConsoleLogEnabled(val: boolean) {
  enabled = val
}

// Flatten a multidimensional object
// tslint:disable-next-line: no-any
export const flattenObject = (inputObj: any): any => {
  if (!inputObj || !Object.assign) {
    return inputObj
  }

  const flattenedOutput: { [key: string]: unknown } = {}
  Object.keys(inputObj).forEach(key => {
    if (typeof inputObj[key] === 'object') {
      Object.assign(flattenedOutput, flattenObject(inputObj[key]))
    } else {
      flattenedOutput[key] = inputObj[key]
    }
  })

  return flattenedOutput
}

export function colorWrite(
  color: string,
  message: string,
  ...data: unknown[]
): void {
  if (!isEnabled()) {
    return
  }

  if (isRunningInIE || !colored) {
    console.log(message, flattenObject(data))
  } else {
    console.log('%c%s', color, message, flattenObject(data))
  }
}

export function trace(message: string, ...data: unknown[]): void {
  colorWrite(traceColor, message, ...data)
}

export function error(message: string, ...data: unknown[]): void {
  colorWrite(errorColor, message, ...data)
}

export function event(message: string, ...data: unknown[]): void {
  colorWrite(eventColor, message, ...data)
}

export function assert(
  condition: unknown,
  message: string,
  ...data: unknown[]
): void {
  if (!isEnabled()) {
    return
  }

  // comment out to reduce noise
  if (window && !('Firebug' in window)) {
    console.assert(condition, message, ...data)
  } else if (!condition) {
    error(`Assertion failure: ${message}`, ...data)
  }
}

export function debug(
  condition: unknown,
  message: string,
  ...data: unknown[]
): void {
  if (!isEnabled()) {
    return
  }

  assert(condition, message, data)

  // enable debugger to stopping execution
  if (!condition) {
    debugger
  }
}
